
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiUnderwayusingengine as ObiUnderwayusingengineElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-underwayusingengine.js';
 
 
 

 
 export const ObiUnderwayusingengine = createComponent({
   react: React,
   tagName: 'obi-underwayusingengine',
   elementClass: ObiUnderwayusingengineElement,
   events: {
     
   }
  });
 
 